import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MaintenanceService } from '../../../../techopsv4/services/maintenanceService';
import { CommonModelService } from '../../../../padu-reporting/capability/common-model.service';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-assign-leader-pop-up',
    templateUrl: './assign-leader-pop-up.component.html',
    styleUrls: ['./assign-leader-pop-up.component.css'],
    standalone: false
})
export class AssignLeaderPopUpComponent {

  @Input() lobDetails: any;
  @Output() closePopUp: EventEmitter<any> = new EventEmitter<any>();
  @Input() reloadData: any;
  LOB_ID: string;
  decomlobName: string = '';
  private subject: Subject<string> = new Subject();
  comments: string;
  decomTarget: number;
  decomYear: number;
  leaderMsid: string;
  leaderName: string;
  users: any[] = [];
  leaderValueChanged: boolean = false;
  decomTargetValueChanged: boolean = false;
  commentsChanged: boolean = false;
  decomYearValueChanged: boolean = false;
  enableApply: boolean = false;
  currentYear = new Date().getUTCFullYear();
  leaderPrevAssignedData: any;
  public YearsList: any[] = [
    {label:this.currentYear,value:this.currentYear},
    {label:this.currentYear+1,value:this.currentYear+1}
  ];

  constructor(private maintenanceService: MaintenanceService,
    private commonService: CommonModelService,
    public toaster: ToastrService,) {
  }

  ngOnInit() {
    this.subject.pipe(
      debounceTime(500)
    ).subscribe(searchObj => {
      this.handleSearch(searchObj);
    });    
  }
  ngOnChanges() {
    if(this.lobDetails) {
      const lobId = this.lobDetails.childDataSource._data.value[0].LobID;
      if(lobId){
        this.lobDetails['LobID'] = lobId;
        this.loadDetails(this.lobDetails['LobID']);
      }
      this.decomlobName = this.lobDetails['DecomLobName'];
    }
    this.users = [];
    this.enableApply = false;
    this.leaderValueChanged = false;
    this.decomYearValueChanged = false;
    this.decomTargetValueChanged = false;
    this.commentsChanged = false;
    this.comments = null;
    this.leaderMsid = undefined;
    this.leaderName = undefined;
    this.decomTarget = undefined;
    this.decomYear = undefined;
  }
  selectionChanged(value, type) {
    if(type == 'leader') {
      if(value) {
        this.leaderMsid = value == "" ? null : value.MSId;
        this.leaderName = value == "" ? null : value.displayName;
      }
      else {
        this.leaderMsid = null;
        this.leaderName = 'None';
      }
    } 
    else if(type == 'decomYear') {
      this.decomYear = value;
    }
    else if(type == 'comments' && this.comments == "") {
      this.comments = null;
    }
    if(this.leaderPrevAssignedData) {
      if(this.leaderPrevAssignedData['Leader_Msid'] != this.leaderMsid || 
        this.leaderPrevAssignedData['Leader_Name'] != this.leaderName) {
        this.leaderValueChanged = true;
      }
      this.decomTargetValueChanged = this.leaderPrevAssignedData['Decom_Target'] != this.decomTarget ? true:false;
      this.decomYearValueChanged = this.leaderPrevAssignedData['Decom_Target_Year'] != this.decomYear ? true:false;
      this.commentsChanged = this.leaderPrevAssignedData['Comments'] != this.comments ? true:false;
      if(this.leaderValueChanged || this.decomTargetValueChanged || this.decomYearValueChanged || this.commentsChanged) {
        this.enableApply = true;
      } 
      else {
        this.enableApply = false;
      }
    }
    else {
      if(this.comments || this.decomTarget || this.decomYear || this.leaderMsid || this.leaderName) {
        this.enableApply = true;
      }
      else {
        this.enableApply = false;
      }
    }
  }
  loadDetails(LOB_ID) {
    this.maintenanceService.getLobDecomMapping(LOB_ID).subscribe(data => {
      if(data) {
        this.leaderPrevAssignedData = data;
        this.comments = data.Comments;
        this.decomTarget = data.Decom_Target;
        this.decomYear = data.Decom_Target_Year;
        this.leaderMsid = data.Leader_Msid;
        this.leaderName = data.Leader_Name;
      } else {
        this.comments = null;
        this.decomTarget = undefined;
        this.decomYear = undefined;
        this.leaderMsid = undefined;
        this.leaderName = '';
      }
    });
  }
  keyUpSearch(event) {
    const p: any = {}
    p['search'] = event.target.value;
    if (event.target.value && event.target.value.length >= 3) {
      this.subject.next(p);
    }
    else {
      this.users = [];
    }
  }
  handleSearch(value) {
    this.commonService.getLDAPUsers(value.search).subscribe(dataStream => {
      this.users = [];
      dataStream.forEach(element => {
        this.users.push({ 
          givenName: element.givenName, 
          sn: element.sn,
          mail: element.mail,
          displayName: element.displayName,
          employeeID: element.employeeID,
          MSId: element.cn,
          middleName: element.middleName,
        });
      });
    }, (error) => { 
      console.error(error);
    });
  }
  applyLeaderDecomMapping() {
    this.enableApply = false;
    this.decomTarget = this.decomTarget == undefined ? null : this.decomTarget;
    this.decomYear = this.decomYear == undefined ? null : this.decomYear;
    this.comments = (this.comments == undefined || this.comments == "") ? null : this.comments;
    this.leaderMsid = this.leaderMsid == undefined ? null : this.leaderMsid;
    this.leaderName = this.leaderName == undefined ? null : this.leaderName;
    const body = {};
    body["LOB_ID"] = this.lobDetails['LobID'];
    if(this.leaderValueChanged) {
      body['Leader_Msid'] = this.leaderMsid == '' ? null : this.leaderMsid;
      body['Leader_Name'] = this.leaderName == 'None' ? null : this.leaderName;
    }
    if((this.decomYear && !this.decomTarget) || (!this.decomYear && this.decomTarget)) {
      this.toaster.error(`Please select both Decom Target Year & Decom Target`, '', { timeOut: 10000, positionClass: 'toast-top-center' });
      return;
    }
    if(this.decomTargetValueChanged) {
      body['Decom_Target'] = this.decomTarget;
    }
    if(this.decomYearValueChanged) {
      body['Decom_Target_Year'] = this.decomYear;
    }
    if(this.commentsChanged) {
      body['Comments'] = this.comments;
    }
    this.maintenanceService.saveLobDecomMapping(body).subscribe(res => {
      if(res) {
        this.toaster.success('Successfully updated details', '', { timeOut: 5000, positionClass: 'toast-top-center' });
      }
      this.closePopUp.emit();
    }, (error) => {
      console.error(error);
      this.toaster.error(`Something went wrong`, '', { timeOut: 5000, positionClass: 'toast-top-center' });
      this.closePopUp.emit();
    });
  }
}
